// Index

// Components
import Nav from './components/Nav';
import LinksNav from './components/LinksNav';
// import Spots, { initSpots } from './components/Spots.js';
import { PlayPauseButton } from './components/PlayPauseButton.js';

// Services
import { loadSheetData } from './services/sheets.js';

// CSS
import '../styles/app.css';
import '../styles/sheets.css';
import '../styles/video.css';

// JS
import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { CustomEase } from "gsap/CustomEase";
import * as Tone from 'tone';

// Create Harry Story audio player
const harryStoryPlayer = new Tone.Player({
    url: require('url:../audio/WINDVege__2.m4a'),
    volume: -Infinity,
    loop: true
}).toDestination();

// Scroll-responsive noise generator
function createScrollNoise() {
    const noise = new Tone.Noise("brown").toDestination();
    const filter = new Tone.Filter(400, "lowpass").toDestination();
    noise.connect(filter);
    
    let noiseTimeout;
    let lastScrollTime = Date.now();
    let scrollVelocity = 0;
    
    return {
        start: () => {
            Tone.start();
            noise.volume.value = -Infinity; // Start silent
            noise.start();
        },
        updateScroll: (scrollTop, lastScrollTop) => {
            const now = Date.now();
            const timeDiff = now - lastScrollTime;
            scrollVelocity = Math.abs(scrollTop - lastScrollTop) / timeDiff;
            
            // Map velocity to volume (much quieter now)
            const targetVolume = Math.min(scrollVelocity * 50, -20);
            noise.volume.rampTo(targetVolume, 0.05);
            
            // Modulate filter frequency based on scroll speed
            const targetFreq = Math.max(200, Math.min(2000, 800 + (scrollVelocity * 1000)));
            filter.frequency.rampTo(targetFreq, 0.05);
            
            // Clear any existing timeout
            if (noiseTimeout) clearTimeout(noiseTimeout);
            
            // Two-stage fade out after scrolling stops
            noiseTimeout = setTimeout(() => {
                // First stage: quick fade to a lower volume
                noise.volume.rampTo(-30, 0.3);
                filter.frequency.rampTo(600, 0.3);
                
                // Second stage: longer, more gradual fade to silence
                setTimeout(() => {
                    noise.volume.rampTo(-Infinity, 2);
                    filter.frequency.rampTo(400, 2);
                }, 500);
            }, 10);
            
            lastScrollTime = now;
        },
        cleanup: () => {
            noise.stop();
            noise.dispose();
            filter.dispose();
        }
    };
}

// Load HTMX
const script = document.createElement('script');
script.src = 'https://unpkg.com/htmx.org@1.9.10';
document.head.appendChild(script);

// Initialize components and UI
function initializeUI() {
    const navContainer = document.querySelector('header');
    const linksNavContainer = document.querySelector('main .JACKS0N__nav');
    
    if (navContainer) {
        navContainer.innerHTML = Nav();
    }
    
    if (linksNavContainer) {
        // Get current page path for active state
        const currentPage = window.location.pathname;
        linksNavContainer.innerHTML = LinksNav(currentPage);
    }

    gsap.registerPlugin(Draggable, CustomEase);

    // JACKS0N NAV
    var toggleLookNav = document.querySelectorAll('.toggle__nav');
    const mainLook = document.querySelectorAll('.JACKS0N');

    toggleLookNav.forEach(function (toggleButton) {
        if (toggleButton instanceof HTMLButtonElement) {
            toggleButton.onclick = function (event) {
                mainLook.forEach(look => look.classList.toggle("w__nav"));

                if (toggleButton.getAttribute("aria-expanded") == "true") {
                    toggleButton.setAttribute("aria-expanded", "false");
                } else {
                    toggleButton.setAttribute("aria-expanded", "true");
                };
            };
        }
    });

    // Video setup
    const mainVideo = document.querySelector('.video__main video');
    const overlayVideo = document.querySelector('.video__overlay video');
    const overlayVideoContainer = document.querySelector('.video__overlay');
    const controlButton = overlayVideoContainer.querySelector('.video-control-btn');
    const mainVideoContainer = document.querySelector('.video__main');

    // Ensure videos are muted
    mainVideo.muted = true;
    overlayVideo.muted = true;

    // Pause videos initially
    mainVideo.pause();
    overlayVideo.pause();

    // Remove controls if present
    [mainVideo, overlayVideo].forEach(video => {
        if (video.hasAttribute("controls")) {
            video.removeAttribute("controls");
        }
        // Prevent context menu
        video.addEventListener("contextmenu", function (e) { 
            e.preventDefault(); 
            e.stopPropagation(); 
        }, false);
    });

    // Video Controls
    controlButton.addEventListener('click', (e) => {
        e.stopPropagation();
        overlayVideoContainer.classList.toggle('minimized');
        
        const maximizePath = controlButton.querySelector('path.maximize');
        const minimizePath = controlButton.querySelector('path.minimize');
        maximizePath.style.display = overlayVideoContainer.classList.contains('minimized') ? 'none' : 'block';
        minimizePath.style.display = overlayVideoContainer.classList.contains('minimized') ? 'block' : 'none';
    });

    // Video play/pause controls
    // [overlayVideoContainer, mainVideoContainer].forEach(container => {
    //     container.addEventListener('click', function(e) {
    //         // if (e.target.closest('.video-control-btn')) return;
    //         const playButton = document.querySelector('#play-btn');
    //         if (playButton) playButton.click();
    //     });
    // });

    // Make overlay video draggable
    if (overlayVideoContainer) {
        Draggable.create(overlayVideoContainer, {
            type: "x,y",
            edgeResistance: 0.65,
            bounds: "section",
            onDragStart: function() {
                gsap.to(this.target, {
                    scale: 1.02,
                    duration: 0.2
                });
                // Start and fade in Harry Story
                harryStoryPlayer.start();
                harryStoryPlayer.volume.rampTo(-10, 0.5);
            },
            onDrag: function() {
                gsap.to(this.target, {
                    duration: 0.2
                });
            },
            onDragEnd: function() {
                gsap.to(this.target, {
                    scale: 1,
                    duration: 0.2
                });
                // Fade out and stop Harry Story
                harryStoryPlayer.volume.rampTo(-Infinity, 0.5);
                setTimeout(() => {
                    harryStoryPlayer.stop();
                }, 500);
            }
        });
    }

    // Interactive Sound Element for control__wrapper
    const controlWrapper = document.querySelector('.control__wrapper');
    if (controlWrapper) {
        // Create audio player for interactive element
        const interactivePlayer = new Tone.Player({
            url: require('url:../audio/WINDVege__2.m4a'),
            volume: -Infinity,
            loop: false
        });

        // Create effects for interactive element
        const interactiveReverb = new Tone.Reverb({
            decay: 0.8,
            wet: 0.3
        }).toDestination();

        const interactiveDelay = new Tone.FeedbackDelay({
            delayTime: 0.15,
            feedback: 0.3,
            wet: 0.4
        }).toDestination();

        // Connect the effects chain
        interactivePlayer.chain(interactiveDelay, interactiveReverb, Tone.Destination);

        // GSAP animations for visual feedback
        const particlePhase = controlWrapper.querySelector('.particle-phase');
        
        // Click animation timeline
        const clickAnimation = gsap.timeline({ paused: true })
            .to(controlWrapper, {
                scale: 0,
                duration: 0.1,
                
                ease: "power2.out"
            })
            .to(controlWrapper, {
                scale: 1.5,
                duration: 0.2,
                ease: "power2.inOut"
            })
 
            .to(particlePhase, {
                opacity: 1,
                scale: 1,
                duration: 0.5,
                ease: "power2.inOut"
            });

        // Click handler
        controlWrapper.addEventListener('click', async (e) => {
            e.stopPropagation();
            
            // Start Tone.js context on first user interaction
            await Tone.start();
            
            // Play sound
            interactivePlayer.start();
            interactivePlayer.volume.rampTo(2, 0.05);
            
            // Play animation
            clickAnimation.restart();
            
            // Stop sound after short duration
            setTimeout(() => {
                interactivePlayer.volume.rampTo(-Infinity, 0.8);
                setTimeout(() => {
                    interactivePlayer.stop();
                }, 800);
            }, 200);
        });

        // Cleanup interactive audio on page unload
        window.addEventListener('beforeunload', () => {
            interactivePlayer.stop();
            interactivePlayer.dispose();
            interactiveReverb.dispose();
            interactiveDelay.dispose();
        });
    }
}

// Load sheet data after UI is initialized
function loadSheets() {
    // Only load sheets that have containers in the DOM
    const mainContainer = document.getElementById('table-container');
    const secondaryContainer = document.getElementById('secondary-table-container');
    const newsContainer = document.getElementById('news-table-container');

    if (mainContainer) {
        loadSheetData('table-container', 'main');
    }

    if (secondaryContainer) {
        loadSheetData('secondary-table-container', 'secondary');
    }

    if (newsContainer) {
        loadSheetData('news-table-container', 'news');
    }
}

document.addEventListener('DOMContentLoaded', function () {
    // First initialize UI
    initializeUI();
    // Then load sheets
    loadSheets();
    // Initialize spots after DOM is loaded
    // initSpots();

    // Render PlayPauseButton in #audio-controls
    const audioControls = document.getElementById('audio-controls');
    if (audioControls) {
      const playButton = PlayPauseButton({
        container: audioControls,
        audioUrl: require('url:../audio/09.mp3'),
        buttonId: 'play-btn',
        labelPlay: 'Play',
        labelPause: 'Pause',
        showAudioControlsLabel: true,
        onPlay: () => {
          const mainVideo = document.querySelector('.video__main video');
          const overlayVideo = document.querySelector('.video__overlay video');
          const overlayVideoContainer = document.querySelector('.video__overlay');
          const mainVideoContainer = document.querySelector('.video__main');
          
          mainVideo.play();
          overlayVideo.play();
          overlayVideoContainer.classList.add('is-playing');
          mainVideoContainer.classList.add('is-playing');
        },
        onPause: () => {
          const mainVideo = document.querySelector('.video__main video');
          const overlayVideo = document.querySelector('.video__overlay video');
          const overlayVideoContainer = document.querySelector('.video__overlay');
          const mainVideoContainer = document.querySelector('.video__main');
          
          mainVideo.pause();
          overlayVideo.pause();
          overlayVideoContainer.classList.remove('is-playing');
          mainVideoContainer.classList.remove('is-playing');
        }
      });
    }
});